<template>
  <div>
    <BaseCard gray mb v-test="'stripe-plan-free-card'">
      <div :class="$style.labelContainer" mb>
        <BaseLabel color="success">{{
          t('subscription.cancelation_flow.offer_label')
        }}</BaseLabel>
        <BaseCheck checked />
      </div>
      <div :class="$style.planHeader">
        <BaseHeading :mb="0.5">
          {{ t('subscription.stripe.types.lite.name') }}
        </BaseHeading>
        <div :class="$style.priceContainer">
          <BaseText bold mr v-test="`stripe-plan-free-price`">
            {{ filters.currency(0, 'EUR') }}
            {{ t('subscription.cancelation_flow.offer.fees') }}
          </BaseText>
          <BaseIcon
            :name="isFeaturesExpanded ? 'chevron-up' : 'chevron-down'"
            size="s"
            color="secondary"
            clickable
            :ml="0.5"
            @click="toggleFeatures"
            v-test="`toggle-features-icon-free`"
          />
        </div>
      </div>
      <div
        v-if="isFeaturesExpanded"
        :id="featureContainerId"
        :class="$style.featuresContainer"
      >
        <div :class="$style.feature">
          <BaseIcon name="check" color="success" size="l" :mr="0.5" />
          <BaseText>{{ t('subscription.stripe.features.calendar') }}</BaseText>
        </div>
        <div :class="$style.feature">
          <BaseIcon name="check" color="success" size="l" :mr="0.5" />
          <BaseText>{{
            t('subscription.features.client_management')
          }}</BaseText>
        </div>
        <div :class="$style.feature">
          <BaseIcon name="check" color="success" size="l" :mr="0.5" />
          <BaseText>{{
            t('subscription.features.appointment_reminders')
          }}</BaseText>
        </div>
        <div :class="$style.feature">
          <BaseIcon name="check" color="success" size="l" :mr="0.5" />
          <BaseText>{{
            t('subscription.features.marketplace_profile')
          }}</BaseText>
        </div>
        <div :class="$style.feature">
          <BaseIcon name="check" color="success" size="l" :mr="0.5" />
          <BaseText>{{
            t('subscription.features.marketplace_online_bookings')
          }}</BaseText>
        </div>
        <div :class="$style.feature">
          <BaseIcon name="check" color="success" size="l" :mr="0.5" />
          <BaseText>{{
            t('subscription.features.marketplace_online_payments')
          }}</BaseText>
        </div>
      </div>
      <BaseText italic mt>
        {{ t('subscription.stripe.types.lite.commission_note') }}
      </BaseText>
    </BaseCard>

    <CurrentPlanDetails />
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import filters from '../../../../../filters';
import { useI18n } from 'vue-i18n';
import CurrentPlanDetails from './CurrentPlanDetails.vue';

const { t } = useI18n();

const isFeaturesExpanded = ref(true);

const toggleFeatures = (): void => {
  isFeaturesExpanded.value = !isFeaturesExpanded.value;
};

const featureContainerId = computed(
  () => `features-free-${Math.random().toString(36).substring(7)}`,
);
</script>

<style lang="scss" module>
.labelContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: $spacing;
}

.planHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.priceContainer {
  display: flex;
  align-items: center;
}

.featuresContainer {
  margin-top: $spacing;
}

.feature {
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: $spacing * 0.5;
  }
}
</style> 
